export const MAX_WORK_SHIFT_DURATION_HOURS = 10

export const MATRICULE_PREFIX = 'AGD'
export const MATRICULE_INTERIM_PREFIX = 'AGDI'
export const MATRICULE_DIGITS = 6

export const WORK_SHIFT_STEP_DURATION_MINUTES = 5

export const MINIMUM_BREAK_BETWEEN_SHIFTS_MINUTES = 20
export const MAX_WEEKLY_HOURS = 35
export const MAX_CONSECUTIVE_WORK_DAYS = 6

export const CLOCK_COMMENT_REQUIRED_THRESHOLD_MINUTES = 5

export const CLOCK_PHOTO_RETENTION_DAYS = 15
